// extracted by mini-css-extract-plugin
export default {"stats":"Stats_stats__osIzZ","stats__wrapper":"Stats_stats__wrapper__3FXT3"};